import { createResource } from '../utils/resource'

const certificateTemplateStore = createResource('certificateTemplate', {})

export default certificateTemplateStore
